<app-grid
  [rowData]="(recourseCriteria$ | async) || []"
  [columnDefs]="columnDefs"
  [defaultColumnDef]="defaultColumnDef"></app-grid>

<pas-sidebar-holder [hasNavbar]="true">
  <div class="sidebar-contents">
    <ng-container>
      <div class="sidebar-element sidebar-row">
        <ul class="navbar-nav">
          @if (canAddAndEditRecourseCriteria) {
            <li class="nav-item">
              <a (click)="addRecourseCriteria()" class="nav-link link-sidebar">
                <i class="material-icons">add_circle_outline</i>
                <span class="hidden-md-down">{{ 'recourceCriteria.add' | translate }}</span>
              </a>
            </li>
          }
        </ul>
      </div>
    </ng-container>
  </div>
</pas-sidebar-holder>

<ng-template #modalTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="(isFormValidAndModalNotOpenInDisplayOnlyMode$ | async) && canAddAndEditRecourseCriteria"
    (confirm)="onConfirm()"
    (cancel)="onCancel()"
    confirmationMessage=""
    modalTitle="{{ 'recourceCriteria.add' | translate }}"
    acceptButtonLbl="{{ 'SAVE' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}">
    <app-recourse-criteria-editor></app-recourse-criteria-editor>
  </tur-generic-modal-content>
</ng-template>
